import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {toast} from "react-toastify";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

export const getAllListing = createAsyncThunk(
  "listing/getAllListing",
  async (obj, {rejectWithValue}) => {
    let res;
    try {
      if (obj.allocated_to) {
        res = await api.get(
          `${WiseBerryAPIEnv}listing?limit=30&direction=desc&sort_by=created_at&state=1&allocated_to=${obj.allocated_to}&page=${obj.page}`
        );
      } else {
        res = await api.get(
          `${WiseBerryAPIEnv}listing?limit=30&direction=desc&sort_by=created_at&state=1&page=${obj.page}`
        );
      }
      // debugger;
      if (res.data.data && Array.isArray(res.data.data)) {
        res.data.data.sort((a, b) => a.price_from - b.price_from);
      }
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response ? err.response.data : err.message);
    }
  }
);

export const getListingById = createAsyncThunk(
  "listing/getListingById",
  async (id, {rejectWithValue}) => {
    try {
      const res = await api.get(`${WiseBerryAPIEnv}listing/${id}`);

      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const getNotes = createAsyncThunk(
  "listing/getNotes",
  async ({id, page}, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}listing/notes?all=1&listing=${id}&page=${page}&limit=30`
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const getTimeline = createAsyncThunk(
  "listing/getTimeline",
  async (id, {rejectWithValue}) => {
    try {
      const res1 = api.get(
        `${WiseBerryAPIEnv}listing/timeline?direction=past&limit=1000&listing=${id}`
      );
      const res2 = api.get(
        `${WiseBerryAPIEnv}listing/timeline?limit=1000&listing=${id}`
      );
      const results = await Promise.all([res1, res2]);

      let combinedData = [...results[0].data.data, ...results[1].data.data];

      combinedData = combinedData.sort(
        (a, b) => new Date(b.timeline_date) - new Date(a.timeline_date)
      );
      return combinedData;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const postNote = createAsyncThunk(
  "listing/postNote",
  async (formData, {rejectWithValue}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}note`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getBuyers = createAsyncThunk(
  "listing/getBuyers",
  async (search, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}buyer?limit=10&search_kw=${search}`
      );

      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const createListingBuyer = createAsyncThunk(
  "listing/createListingBuyer",
  async (obj, {rejectWithValue}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}contact`, obj, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      let buyerType;
      if (res.data?.data?.id) {
        buyerType =
          res.data.data.types.find(
            (type) => type.name === "Buyer" && type.buyer_id !== undefined
          ) || null;

        if (buyerType === null) {
          try {
            const resBuyer = await api.post(
              `${WiseBerryAPIEnv}buyer`,
              {
                buyer_contact: {
                  id: res.data.data.id,
                },
              },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            buyerType = resBuyer.data.data;
            return buyerType; // returning buyerType after the second API call
          } catch (innerError) {
            // specific error handling for the inner API call
            return rejectWithValue(
              "Error creating a new buyer: " + innerError.message
            );
          }
        } else {
          return buyerType;
        }
      }
    } catch (error) {
      // specific error handling for the outer API call
      return rejectWithValue("Error contacting the API: " + error.message);
    }
  }
);

// /buyer/send-listing-contract

// const obj = {
//   listings: [30938],
//   buyers: [501149]
// };
export const sendContract = createAsyncThunk(
  "listing/sendContract",
  async (obj, {rejectWithValue}) => {
    try {
      const res = await api.post(
        `${WiseBerryAPIEnv}buyer/send-listing-contract`,
        obj,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Listing Contract Sent");
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const sendListingPack = createAsyncThunk(
  "listing/sendListingPack",
  async (obj, {rejectWithValue}) => {
    // debugger;
    try {
      const res = await api.post(
        `${WiseBerryAPIEnv}buyer/send-listing-pack`,
        obj,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      toast.success("Listing Pack Sent");
      return res.data.message;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getMatchedBuyers = createAsyncThunk(
  "listing/getMatchedBuyers",
  async ({listingId, limit = 10, page = 1}, {rejectWithValue}) => {
    try {
      const response = await api.get(
        `${WiseBerryAPIEnv}listing/matched-buyers?limit=${limit}&listing=${listingId}&loadMore=true&match_by=price&page=${page}&direction=ASC&sort_by=price_from`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

let initialState = {
  // getAllListing
  listings: {},
  loading: false,
  listingsError: null,

  //   getListingById
  listingDetails: {},
  loadingDetails: false,
  listingDetailsError: null,

  //   getTimeline
  timeline: [],
  loadingTimeline: false,
  timelineError: null,

  //   getNotes
  notes: {},
  loadingNotes: false,
  notesError: null,

  //   postNote
  postNote: [],
  loadingPostNote: false,
  postNoteError: null,

  //get buyers
  buyers: [],
  loadingBuyers: false,
  buyersError: null,

  // CreateListingBuyer
  buyerId: null,
  loadingBuyerId: false,
  buyerIdError: null,

  // sendContract
  contractStatus: null,
  loadingContractStatus: false,
  contractStatusError: null,

  // sendListingPack
  listingPackStatus: null,
  loadingListingPackStatus: false,
  listingPackStatusError: null,

  // getMatchedBuyers
  matchedBuyers: {},
  loadingMatchedBuyers: false,
  matchedBuyersError: null,

  // Tab State
  activeTab: "my_listings",
};

const listingSlice = createSlice({
  name: "listings",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      // Reducer to update the active tab
      state.activeTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllListing.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllListing.fulfilled, (state, action) => {
        if (action.payload.current_page === 1) {
          state.listings = action.payload;
        } else {
          state.listings.data = [
            ...state.listings.data,
            ...action.payload.data,
          ];
          state.listings.current_page = action.payload.current_page;
        }
        state.loading = false;
        state.listingsError = null;
      })

      .addCase(getAllListing.rejected, (state, action) => {
        state.loading = false;
        state.listingsError = action.payload;
        state.listings = {};
      })

      //   getNotes
      .addCase(getNotes.pending, (state) => {
        state.loadingNotes = true;
      })
      .addCase(getNotes.fulfilled, (state, action) => {
        if (action.payload.current_page === 1) {
          state.notes = action.payload;
        } else {
          state.notes.data = [...state.notes.data, ...action.payload.data];
          state.notes.current_page = action.payload.current_page;
        }
        state.loadingNotes = false;
        state.notesError = null;
      })

      .addCase(getNotes.rejected, (state, action) => {
        state.loadingNotes = false;
        state.notesError = action.payload;
        state.notes = {};
      })

      //   getListingById
      .addCase(getListingById.pending, (state) => {
        state.loadingDetails = true;
      })
      .addCase(getListingById.fulfilled, (state, action) => {
        state.listingDetails = action.payload;
        state.loadingDetails = false;
        state.listingDetailsError = null;
      })

      .addCase(getListingById.rejected, (state, action) => {
        state.loadingDetails = false;
        state.listingDetailsError = action.payload;
        state.listingDetails = {};
      })

      //   getTimeline
      .addCase(getTimeline.pending, (state) => {
        state.loadingTimeline = true;
      })
      .addCase(getTimeline.fulfilled, (state, action) => {
        state.timeline = action.payload;
        state.loadingTimeline = false;
        state.timelineError = null;
      })

      .addCase(getTimeline.rejected, (state, action) => {
        state.loadingTimeline = false;
        state.timelineError = action.payload;
        state.timeline = [];
      })

      //   postNote
      .addCase(postNote.pending, (state) => {
        state.loadingPostNote = true;
      })
      .addCase(postNote.fulfilled, (state, action) => {
        state.postNote = action.payload;
        state.loadingPostNote = false;
        state.postNoteError = null;
      })

      .addCase(postNote.rejected, (state, action) => {
        state.loadingPostNote = false;
        state.postNoteError = action.payload;
        state.postNote = [];
      })

      // getBuyers
      .addCase(getBuyers.pending, (state) => {
        state.loadingBuyers = true;
      })
      .addCase(getBuyers.fulfilled, (state, action) => {
        state.buyers = action.payload;
        state.loadingBuyers = false;
        state.buyersError = null;
      })

      .addCase(getBuyers.rejected, (state, action) => {
        state.loadingBuyers = false;
        state.buyersError = action.payload;
        state.buyers = [];
      })

      // createListingBuyer

      .addCase(createListingBuyer.pending, (state) => {
        state.loadingBuyerId = true;
      })
      .addCase(createListingBuyer.fulfilled, (state, action) => {
        state.buyerId = action.payload;
        state.loadingBuyerId = false;
        state.buyerIdError = null;
      })

      .addCase(createListingBuyer.rejected, (state, action) => {
        state.loadingBuyerId = false;
        state.buyerIdError = action.payload;
        state.buyerId = null;
      })

      // sendContract
      .addCase(sendContract.pending, (state) => {
        state.loadingContractStatus = true;
      })
      .addCase(sendContract.fulfilled, (state, action) => {
        state.contractStatus = action.payload;
        state.loadingContractStatus = false;
        state.contractStatusError = null;
      })
      .addCase(sendContract.rejected, (state, action) => {
        state.loadingContractStatus = false;
        state.contractStatusError = action.payload;
        state.contractStatus = null;
      })

      // sendListingPack
      .addCase(sendListingPack.pending, (state) => {
        state.loadingListingPackStatus = true;
      })
      .addCase(sendListingPack.fulfilled, (state, action) => {
        state.listingPackStatus = action.payload;
        state.loadingListingPackStatus = false;
        state.listingPackStatusError = null;
      })
      .addCase(sendListingPack.rejected, (state, action) => {
        state.loadingListingPackStatus = false;
        state.listingPackStatusError = action.payload;
        state.listingPackStatus = null;
      })

      .addCase(getMatchedBuyers.pending, (state) => {
        state.loadingMatchedBuyers = true;
      })
      .addCase(getMatchedBuyers.fulfilled, (state, action) => {
        if (action.payload.current_page === 1) {
          state.matchedBuyers = action.payload;
        } else {
          state.matchedBuyers.data = [
            ...state.matchedBuyers.data,
            ...action.payload.data,
          ];
          state.matchedBuyers.current_page = action.payload.current_page;
        }
        // state.matchedBuyers.data.sort((a, b) => a.price_from - b.price_from);
        state.loadingMatchedBuyers = false;
        state.matchedBuyersError = null;
      })

      .addCase(getMatchedBuyers.rejected, (state, action) => {
        state.loadingMatchedBuyers = false;
        state.matchedBuyersError = action.payload;
        state.matchedBuyers = {};
      });
  },
});
export const {setActiveTab} = listingSlice.actions;
export default listingSlice.reducer;
